import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box
} from '@mui/material';

import DateFilter from '@inovua/reactdatagrid-community/DateFilter'

import { useNavigate, Link } from 'react-router-dom';

import CommonBreadcumbs from '../common/CommonBreadcumbs';
import DataGridToolbar from '../common/DataGridToolbar';
import DataGridTable from '../common/DataGridTable';
import CommonRestricted from '../common/CommonRestricted';

import { icons } from '../common/CommonIcons';
import { useDataGridParams } from '../../hooks/useDataGridParams';
import { useSystemPrompt } from '../../hooks/useSystemPrompt';
import { useAuditTrailTags, auditTrailTypes, targetTypes } from '../../hooks/api/useAuditTrailTags';
import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../hooks/usePermissions';

export default function ListAuditTrailTags({
    routeType
}) {

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();
    const { list, remove } = useAuditTrailTags({ auditTrailType: auditTrailTypes.auditTag, targetType: targetTypes.auditTrail });

    const { defineColumns, columns, filterValues } = useDataGridParams('id')
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.audit.id, scopeTypes.audit.auditTrailTag.id)

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const gridRef = useRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            const result = await list(props)

            return {
                data: result?.data?.tags,
                count: result?.data?.total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }
    }

    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([
            {
                name: 'target',
                header: 'Target',
            },
            {
                name: 'module',
                header: 'Module'
            },
            {
                name: 'trail_ref',
                header: 'Trail Ref'
            },
            {
                name: 'type',
                header: 'Type'
            },
            {
                name: 'description',
                header: 'Description'
            },
            {
                name: 'tag_key',
                header: 'Tag Key'
            },
            {
                name: 'tag_value',
                header: 'Tag Value'
            },
            {
                name: 'tag_label',
                header: 'Tag Label'
            },
            {
                name: 'tag_description',
                header: 'Tag Description'
            },
        ])
    }

    const handleDelete = async () => {

        try {
            let result = await remove({ ids: selectedIds })

            promptMessage(true, result?.message)
            setRefreshDataGrid(currentVal => currentVal + 1)

        } catch (error) {
            promptMessage(false, error?.message)
        }

    }

    const RenderToolbar = () => {

        const getActionOnClick = () => {

            let handleFunction = null

            if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
                handleFunction = handleDelete
            }

            return handleFunction
        }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={[]}
                actionOnClickRemove={
                    getActionOnClick()
                }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    checkboxColumn:
                        // false,
                        isPermissionAllow({ functionType: functionTypes.remove.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.tags })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle="Tags"
                breadcrumbs={[
                    {
                        displayText: "Audit Trails",
                        props: {
                            href: getRoute("settings/auditTrails")
                        }
                    },
                    {
                        displayText: "Tags",
                        props: {
                            color: 'secondary.main'
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}